import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ZefForm, ZefFormsManagerService } from '@zerops/zef/forms';
import { AppState } from '@zerops/zerops/app';
import { FormState, validate, FormControlState, FormGroupState, setErrors } from 'ngrx-forms';
import { required } from 'ngrx-forms/validation';
import { FEATURE_NAME } from './password-change-form.constant';

export interface PasswordChangeFormValue {
  oldPassword: string;
  newPassword: string;
  passwordIsSet: boolean;
}

export type PasswordChangeFormState = FormState<PasswordChangeFormValue>;

@Injectable({ providedIn: 'root' })
export class PasswordChangeForm extends ZefForm<PasswordChangeFormValue> {
  constructor(
    public store: Store<AppState>,
    public formsManager: ZefFormsManagerService
  ) {
    super(
      store,
      formsManager,
      FEATURE_NAME,
      {
        oldPassword: '',
        newPassword: '',
        passwordIsSet: true
      },
      {
        oldPassword: (s: FormControlState<string>, ps: FormGroupState<PasswordChangeFormValue>) => {
          // Guard against null parent state during update cycles
          if (!ps?.controls) {
            return s;
          }

          // Only require old password if user has a password set AND new password is being set
          if (ps.controls.passwordIsSet.value && ps.controls.newPassword.value) {
            return validate(s, required);
          }

          return setErrors(s, {});
        },
        newPassword: (s: FormControlState<string>) => {
          // Allow empty string (removes password)
          if (s.value === '') {
            return s;
          }
          // Otherwise require value
          return validate(s, required);
        }
      }
    );
  }
}
